import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ItemsTableData from "./ItemsTableData";
import SelectOption from "./SelectOption";
import { useDispatch, useSelector } from "react-redux";


function Items() {
  const Navigate = useNavigate();
  const Permissions = useSelector((state) => state.user.userPermissions);
  const addProduct = Permissions.find((o) => o.codename === "add_products");
  const [ShowOptions, setShowOptions] = useState(false);
  return (
    <>
      {!ShowOptions ? (
        <>
          <div className="ml-8 container w-auto mb-7">
            <div className="flex flex-row justify-between w-full items-center">
              <div className="flex flex-row items-center">
                <div>
                  <h2 className="font-Montserrat text-xl font-bold text-black">
                    All Items/Assemblies
                  </h2>
                  <div className="border-b-2 border-blue-200 w-20"></div>
                </div>
              </div>
              <div>
              {!addProduct ===undefined ||  addProduct?.codename ===
              "add_products" ? (
                <button
                  onClick={() => setShowOptions(true)}
                  type="button"
                  className="border-2 border-blue-200 hover:text-white text-base font-Montserrat font-bold text-blue-200 flex-shrink hover:border-blue-100 hover:bg-blue-100 place-content-center rounded-md px-2 py-1 flex flex-grow w-60 "
                >
                  Add Item/Assembly
                </button>
              ) : null
              }
              </div>
            </div>
          </div>
          <ItemsTableData />
        </>
      ) : (
        <>
          <div className="ml-8 container w-auto mb-16">
            <div className="flex flex-row justify-between w-full items-center">
              <div className="flex flex-row items-center">
                <div>
                  <h2 className="font-Montserrat text-xl font-bold text-black">
                    Register New Item/Assembly
                  </h2>
                  <div className="border-b-2 border-blue-200 w-20"></div>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col justify-center w-full place-items-center mb-10">
            <h3 className="font-Roboto text-xl font-medium">
              Select from the following
            </h3>
          </div>
          <SelectOption />
        </>
      )}
    </>
  );
}

export default Items;
